import {networkError, uiInfo, uiSuccess} from "./ui";
import * as R from 'ramda';
import {
  acceptBidInvite$,
  convertBidToProject$,
  createBid$,
  createBidContactListInvites$,
  createBidInvites$,
  createEmailBidInvites$,
  declineBidInvite$,
  deleteBid$,
  getBidInviteById$,
  getBidInvites$,
  getBids$,
  getBidsIndex$,
  leaveBid$,
  setBidViewed$,
  updateBid$,
  updateBidInvitePermissions$
} from "../services/bids";
import {addBidContacts} from "./bidcontacts";
import {clearView, clearViewIndex, extractView, extractViewIndex, setViewCache, setViewIndex} from "./view";
import {doCacheResource} from "./cache";
import {injectProject} from "./projects";

export const ADD_BIDS = 'ADD_BIDS';
export const addBids = (bids) => ({ type: ADD_BIDS, payload: bids });
export const API_GET_BIDS_DONE = 'API_GET_BIDS_DONE';
export const getBidsDone = (response) => ({ type: API_GET_BIDS_DONE, payload: response });
export const API_GET_BID = 'API_GET_BID';
export const getBid = (id) => ({ type: API_GET_BID, payload: { id } });
export const API_GET_BID_DONE = 'API_GET_BID_DONE';
export const getBidDone = (response, callback) => ({ type: API_GET_BID_DONE, payload: { response, callback } });
export const REMOVE_BID = 'REMOVE_BID';
export const removeBid = (bidId) => ({ type: REMOVE_BID, payload: { bidId } });
export const DO_CONVERT_BID = 'DO_CONVERT_BID';
export const doConvertBid = (bidId, projectId) => ({ type: DO_CONVERT_BID, payload: { bidId, projectId } });

export const getBidsIndex = ({ sortby, order, filterby, from, to, status, limit, search }) => async (dispatch, getState) => {
  try {
    let { response, status: response_status } = await getBidsIndex$({
      sortby,
      order,
      filterby,
      from,
      to,
      status,
      limit,
      search
    }).toPromise();
    if (response_status === 204) {
      dispatch(clearViewIndex());
      return;
    }
    if (response === null) return;
    let { results } = response;
    if (results.length > 0) {
      dispatch(setViewIndex(results));
    }
  } catch (error) {
    dispatch(networkError({...error, number: '10005-'+error.status}));
  }
};

export const getBids = ({ sortby, order, filterby, from, to, status, limit, search }) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    let nextSortOffset;
    do {
      dispatch(setViewCache({loading: true}));
      let { response, status: response_status } = await getBids$({
        offset: nextOffset,
        sortoffset: nextSortOffset,
        sortby,
        order,
        filterby,
        from,
        to,
        status,
        limit,
        search
      }).toPromise();
      if (response_status === 204) {
        dispatch(setViewCache({loading: false}));
        dispatch(clearView());
        return;
      }
      if (response === null) {
        dispatch(setViewCache({loading: false}));
        return;
      }
      const { results, offset, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(getBidsDone({ results }));
        nextOffset = R.last(results).resource.id;
        if (sortby) nextSortOffset = R.last(results).resource[sortby];
      }
      dispatch(setViewCache({loading: false}));
    } while (soFar < (limit || theSize) && theSize > limit);
  } catch (error) {
    dispatch(setViewCache({loading: false}));
    dispatch(networkError({...error, number: '10006-'+error.status}));
  }
};

export const createBid = (bid, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await createBid$({ bid }).toPromise();
    let bidId = response;
    ({ response, status } = await getBids$({ id: bidId }).toPromise());
    dispatch(getBidDone(response, callback));
  } catch (error) {
    dispatch(networkError({...error, number: '10007-'+error.status}));
  }
};

export const leaveBid = (bidId) => async (dispatch, getState) => {
  try {
    let { response, status } = await leaveBid$({ bidId }).toPromise();
    dispatch(removeBid(bidId));
    dispatch(extractView([bidId]));
    dispatch(extractViewIndex([bidId]));
  } catch (error) {
    dispatch(networkError({...error, number: '10008-'+error.status}));
  }
};

export const deleteBid = (bidId) => async (dispatch, getState) => {
  try {
    let { response, status } = await deleteBid$({ bidId }).toPromise();
    dispatch(removeBid(bidId));
    dispatch(extractView([bidId]));
    dispatch(extractViewIndex([bidId]));
  } catch (error) {
    dispatch(networkError({...error, number: '10009-'+error.status}));
  }
};

export const updateBid = (bid) => async (dispatch, getState) => {
  try {
    let bidId = bid.id;
    bid = R.compose(
      R.dissoc('addendums'),
      R.dissoc('contactstatus'),
      R.dissoc('viewed')
    )(bid);
    let { response, status } = await updateBid$({ bidId, bid }).toPromise();
    let { response: response2, status: status2 } = await getBids$({ id: bidId }).toPromise();
    dispatch(getBidDone(response2));
  } catch (error) {
    dispatch(networkError({...error, number: '10010-'+error.status}));
  }
};

export const inviteUser = (bidId, userId) => async (dispatch, getState) => {
  try {
    let { response, status } = await createBidInvites$({ bidId: bidId, inviteUserIds: [userId] }).toPromise();
    let invitedUser = response[0];
    ({ response, status } = await getBidInviteById$({ bidId: bidId, userId: invitedUser }).toPromise());
    dispatch(addBidContacts([response]));
  } catch (error) {
    dispatch(networkError({...error, number: '10011-'+error.status}));
  }
};

export const quickInviteUserEmailSingle = (bidId, inviteUserEmail) => async (dispatch, getState) => {
  try {
    dispatch(uiInfo('Sending invite to ' + inviteUserEmail));
    let { response } = await createEmailBidInvites$({ bidId, inviteUserEmails: [inviteUserEmail] }).toPromise();
    ({ response } = await getBidInvites$({ bidId: bidId, id: response }).toPromise());
    dispatch(addBidContacts(response.results));
    dispatch(uiSuccess('Invited ' + inviteUserEmail + ' to bid'));
  } catch (error) {
    dispatch(networkError({...error, number: '10012-'+error.status}));
  }
};

export const inviteUserEmails = (bidId, inviteUserEmails) => async (dispatch, getState) => {
  try {
    let { response } = await createEmailBidInvites$({ bidId, inviteUserEmails }).toPromise();
    let groups = R.splitEvery(40, response);
    for (let group of groups) {
      ({ response } = await getBidInvites$({ bidId: bidId, id: group }).toPromise());
      dispatch(addBidContacts(response.results));
      dispatch(uiSuccess('Mass email invite sent'));
    }
  } catch (error) {
    dispatch(networkError({...error, number: '10013-'+error.status}));
  }
};

export const inviteUserContactLists = (bidId, contactListIds) => async (dispatch, getState) => {
  try {
    let {response} = await createBidContactListInvites$({bidId, contactListIds}).toPromise();
    let groups = R.splitEvery(40, response);
    for (let group of groups) {
      ({ response } = await getBidInvites$({ bidId: bidId, id: group }).toPromise());
      dispatch(addBidContacts(response.results));
    }
  } catch (error) {
    dispatch(networkError({...error, number: '10014-'+error.status}));
  }
};

export const userWillBid = (bidId, status, doGetBid = true) => async (dispatch, getState) => {
  try {
    const serviceHandler$ = status ? acceptBidInvite$ : declineBidInvite$;
    let { response } = await serviceHandler$({ bidId }).toPromise();
    doGetBid && dispatch(getBid(bidId));
  } catch (error) {
    dispatch(networkError({...error, number: '10015-'+error.status}))
  }
};

export const setBidViewed = (bidId) => async (dispatch, getState) => {
  try {
    let { response } = await setBidViewed$({ bidId }).toPromise();
    // dispatch(getBid(bidId));
  } catch (error) {
    dispatch(networkError({...error, number: '10142-'+error.status}))
  }
};

export const updateBidInvitePermissions = (bidId, userId, role) => async (dispatch, getState) => {
  try {
    await updateBidInvitePermissions$({ bidId, userId, role }).toPromise();
    let { response, status } = await getBidInviteById$({ bidId, userId }).toPromise();
    dispatch(addBidContacts([response]));
  } catch (error) {
    dispatch(networkError({...error, number: '10016-'+error.status}));
  }
};

export const cacheBid = (id) => async (dispatch, getState) => {
  try {
    let { response, status } = await getBids$({ id }).toPromise();
    if (!response || status === 404) return;
    dispatch(doCacheResource(response))
  } catch (error) {
    dispatch(networkError({...error, number: '10141-'+error.status}));
  }
};

export const convertBidToProject = (bidId, inviteUserIds = []) => async (dispatch, getState) => {
  try {
    let {response, status} = await convertBidToProject$({bidId, inviteUserIds}).toPromise();
    if (!response || status === 404) return;
    const projectId = response.id;
    dispatch(injectProject(projectId));
    dispatch(doConvertBid(bidId, projectId));
  } catch (error) {
    dispatch(networkError({...error, number: '10144-'+error.status}));
  }
};



// WEBPACK FOOTER //
// ./src/actions/bids.js